import { t } from "i18next";
import { useNavigationLogic } from "../utils/useNavigationLogic";
import useResponsive from "src/utils/useResponsive";

import { ReactComponent as ResellLogoWSXL } from "src/assets/icons/wsxl-zara-pre-owned-new-logo.svg";
import { ReactComponent as ResellLogoWS } from "src/assets/icons/ws-zara-pre-owned-new-logo.svg";
import { ReactComponent as ResellLogoWM } from "src/assets/icons/wm-zara-pre-owned-new-logo.svg";
import { useGridFilterStore } from "src/store/useGridFilters/useGridFilterStore";

export function PreownedLogoButton() {
  const { onLogoClickHandled } = useNavigationLogic();
  const RESET_MAIN_FILTER = useGridFilterStore((state) => state.RESET_MAIN_FILTER);
  const { WSXL, WSXS } = useResponsive();

  const onLogoClickHandle = () => {
    RESET_MAIN_FILTER();
    onLogoClickHandled();
  }

  return (
    <button
      onClick={onLogoClickHandle}
      className="nav-zds__icons__icon__link"
    >
      {WSXS ? <ResellLogoWM aria-label={t("nav-pds__icons__icon")} role="img" /> : WSXL ? <ResellLogoWSXL aria-label={t("nav-pds__icons__icon")} role="img" /> : <ResellLogoWS aria-label={t("nav-pds__icons__icon")} role="img" />}
    </button>
  );
}
